import {Injectable} from '@angular/core';
import {Http, Headers, Response, RequestOptions} from '@angular/http';
import {AuthHttp} from 'angular2-jwt';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';
import {tokenNotExpired} from 'angular2-jwt';

import {AppSettings} from '../app-settings';

@Injectable()
export class AuthenticationService {

    public token: string;
    headers = new Headers({'Accept': 'application/json'});
    options = new RequestOptions({headers: this.headers});


    constructor(private http: Http, private authHttp: AuthHttp) {
        // set token if saved in local storage
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.token = currentUser && currentUser.token;
    }

    login(params){
        return this.http.post(AppSettings.API_STARTPOINT + '/public/api/v1/login', params, this.options)
            .map((response: Response) => {
                let token = response.json() && response.json().token;
                if (token) {
                    this.token = token;
                    sessionStorage.setItem('token', token);
                    localStorage.setItem('token', JSON.stringify({token: token}));
                    localStorage.setItem('userInfo',JSON.stringify(response.json().userInfo));
                    localStorage.removeItem('eventId');
                }
		return response.json();
            })
            .catch(this.extractData);
    }

    userInfo() {
        return this.authHttp.get(AppSettings.API_STARTPOINT + 'user-info')
            .map(this.extractData)
            .catch(this.handleError);
    }


    loggedIn() {
        return (tokenNotExpired() && sessionStorage.getItem('token')) ? true : false;
    }


    logout(): Observable<boolean> {
        // clear token remove user from local storage to log user out
        return this.authHttp.get(AppSettings.API_STARTPOINT + '/public/api/v1/logout', this.options)
            .map((response: Response) => {
                this.token = null;
                localStorage.removeItem('token');
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('userId');
                sessionStorage.removeItem('firstName');
                sessionStorage.removeItem('lastName');
                return true;
            })
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        //console.log(body);
        return body || [];
    }

    private handleError(error: any) {
        //return Observable.throw(window.location.href = '/home');
	//this.router.navigate(['/home']);
        return Observable.throw('error');
    }

    refreshToken(): Observable<any> {
     return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/refresh-token", this.options).map(
      response => {
       this.token = response.json().token;
       sessionStorage.setItem('token', response.json().token);
       localStorage.setItem('token', JSON.stringify({token: response.json().token}));
       return true;
      },
      error => {
       return false;
      }
     );
    }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/auth/authentication.service.ts